import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "relative flex flex-col" }
const _hoisted_2 = { class: "mb-2 text-lg font-semibold" }
const _hoisted_3 = { class: "min-w-full border-separate border-spacing-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-sm font-medium" }
const _hoisted_6 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-sm font-medium" }
const _hoisted_7 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-sm font-medium" }
const _hoisted_8 = { class: "whitespace-nowrap border-b border-gray-200 px-3 py-1.5 text-center text-sm font-medium" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text-gray-700" }
const _hoisted_11 = {
  colspan: "4",
  class: "whitespace-nowrap border-b border-gray-200 px-3 py-4 text-center text-sm font-medium"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiPanel = _resolveComponent("UiPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('report.realtime.queueCallsTable.title')), 1 /* TEXT */),
    _createVNode(_component_UiPanel, {
      class: "flex-1 overflow-y-auto",
      "no-padding": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                                'clientNumber',
                                'destinationNumber',
                                'queueName',
                                'wait',
                            ], (header) => {
                return _createElementVNode("th", {
                  key: header,
                  class: _normalizeClass(["sticky top-0 z-10 whitespace-nowrap border-b border-gray-300 bg-gray-200 px-3 py-1.5 text-sm font-semibold text-gray-800 backdrop-blur backdrop-filter", {
                                'text-left': [
                                    'clientNumber',
                                    'destinationNumber',
                                    'queueName',
                                ].includes(header),
                                'text-center': ['wait'].includes(header),
                            }])
                }, _toDisplayString(_ctx.$t(`report.realtime.queueCallsTable.header.${header}`)), 3 /* TEXT, CLASS */)
              }), 64 /* STABLE_FRAGMENT */))
            ])
          ]),
          ($setup.computedQueueCalls.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.computedQueueCalls, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.key,
                    class: "even:bg-gray-100"
                  }, [
                    _createElementVNode("td", _hoisted_5, _toDisplayString(item.clientNumber), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(item.destinationNumber), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_7, _toDisplayString(item.queueName), 1 /* TEXT */),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(item.wait), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createElementVNode("tr", _hoisted_10, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t('report.realtime.queueCallsTable.empty')), 1 /* TEXT */)
                ])
              ]))
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}